module.exports = __webpack_public_path__ + "images/FTS_International-de6009.png";